import { render } from "./Misericordia.vue?vue&type=template&id=74c1b38b&scoped=true"
import script from "./Misericordia.vue?vue&type=script&lang=js"
export * from "./Misericordia.vue?vue&type=script&lang=js"

import "./Misericordia.vue?vue&type=style&index=0&id=74c1b38b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74c1b38b"]])

export default __exports__